import Home from '../views/Home.vue'
export default {
  path: '/notes',
  name: '装备标准',
  component: Home,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: true,
  children: [
    // 文库
    {
      path: '/notes/standard',
      component: () =>
                import('../views/notes/standard/index'),
      name: '标准文库',
      roles: ['AppUser'],
      hidden: false
    },
    {
      path: '/notes/standard/details',
      component: () =>
                import('../views/notes/standard/details/index.vue'),
      name: '标准正文',
      roles: ['AppUser'],
      hidden: true
    },
    // 帮助
    {
      path: '/help/details',
      component: () =>
                import('../views/notes/help/details/index.vue'),
      name: '常见问题正文',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/help/add',
      component: () =>
                import('../views/notes/help/details/add/index.vue'),
      name: '需求信息', // 添加常见问题
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/help',
      component: () =>
                import('../views/notes/help/index.vue'),
      name: '常见问题列表',
      roles: ['AppUser'],
      hidden: true
    },
    // 资讯
    {
      path: '/information/details',
      component: () =>
                import('../views/notes/information/details/index.vue'),
      name: '装备服务正文',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/information',
      component: () =>
                import('../views/notes/information/index.vue'),
      name: '装备服务列表',
      roles: ['AppUser'],
      hidden: true
    },
    // 消息通知
    {
      path: '/notes/message',
      component: () =>
                import('../views/notes/message/index.vue'),
      name: '消息通知',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/message/details',
      component: () =>
                import('../views/notes/message/details/index.vue'),
      name: '消息通知正文',
      roles: ['AppUser'],
      hidden: true
    },
    // 公告
    {
      path: '/notice/details',
      component: () =>
                import('../views/notes/notice/details/index.vue'),
      name: '工作通知正文',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/notice',
      component: () =>
                import('../views/notes/notice/index.vue'),
      name: '工作通知列表',
      roles: ['AppUser'],
      hidden: true
    }
  ]
}
